export const costPerConditionsDatapoint = 18 * (1 + 3 / 7);
export const costPerForecastsDatapoint = 90 * (1 + 3 / 7);
